export const navHeight = '97px'
export const navHeightMobile = '84px'
export const maxWidth = '1020px'
export const maxWidthSmall = '1020px'
export const xPadding = '60px'
export const xPaddingMobile = '40px'
